export default "__VITE_ASSET__40d23be9__"